module.exports = "/_next/static/images/PipeDataIntoWarehouse@2x-fda330ea23528d09be6c353541a47591.webp";